import { useAppSelector } from "@/app/hooks";
import {
  BAM_MAP_STYLES,
  BAM_MAP_STYLE_DISPLAY_NAMES,
} from "@/constants/mapStyles";
import { EmeraldIcon } from "@emerald-react/icon";
import { EmeraldPopover } from "@emerald-react/popover";
import { EmeraldRadio, EmeraldRadioGroup } from "@emerald-react/radio";
import React from "react";

const MapStyles = (props: { onMapStyleChange: (style: string) => void }) => {
  const { onMapStyleChange } = props;
  const survey = useAppSelector((state) => state.survey.currentSurvey);
  const [value, setValue] = React.useState(survey?.marketMapStyle === 'esriHybrid' ? 'emeraldEsriHybrid' : survey?.marketMapStyle);
  const handleChange = (
    _event?: React.ChangeEvent<Element>,
    _name?: string,
    value?: string | number,
  ) => {
    if (value) {
      setValue(value as string);
      onMapStyleChange(value as string);
    }
  };
  const mapStyles = BAM_MAP_STYLES;
  const displayNames = BAM_MAP_STYLE_DISPLAY_NAMES;

  return (
    <EmeraldPopover
      placement="bottom-start"
      closeOnOutsideClick
      showCloseIcon
      triggerElement={
        <EmeraldIcon
          icon="settings"
          type="outlined"
          variant="symbol"
          className="absolute right-2.5 bottom-2.5 rounded-sm bg-white z-1 p-[2.5px] text-map-dark border-2 border-map-light"
        />
      }
    >
      <div className="w-40 h-62.5 text-map-dark font-body">
        <div className="sticky top-0 bg-white z-10 px-4 py-3 rounded-sm">
          <h2 className="text-sm font-normal">Map Style</h2>
        </div>

        <div className="max-h-50 overflow-y-auto">
          <EmeraldRadioGroup
            defaultValue={value}
            name="mapStyles"
            onChange={handleChange}
            className="px-1"
          >
            {Object.keys(mapStyles).map((style) => (
              <EmeraldRadio
                key={style}
                id={`SC-SelectMapStyle-${displayNames[style]}`}
                label={displayNames[style]}
                value={style}
                className="text-sm"
              />
            ))}
          </EmeraldRadioGroup>
        </div>
      </div>
    </EmeraldPopover>
  );
};

export default MapStyles;
